import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEarthAmericas, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from '../contexts/LanguageContext';
import LeaderboardDisplay from './LeaderboardDisplay';

const ModeSelection = ({ onSelectMode }) => {
  const { t } = useLanguage();

  const getLeaderboardTitle = (mode, difficulty) => {
    const modeText = mode === 'plate' ? t('plateMode') : t('codeMode');
    const diffText = t(difficulty);
    return `${modeText} - ${diffText}`;
  };

  return (
    <div className="mode-selection">
      <h2>{t('chooseModeTitle')}</h2>
      <div className="mode-buttons">
        <div className="mode-btn" onClick={() => onSelectMode('plate')}>
          <div className="mode-icon">
            <FontAwesomeIcon icon={faEarthAmericas} />
          </div>
          <h3>{t('guessCountryFromPlate')}</h3>
          <p>{t('guessCountryDescription')}</p>
        </div>
        <div className="mode-btn" onClick={() => onSelectMode('code')}>
          <div className="mode-icon">
            <FontAwesomeIcon icon={faGlobe} />
          </div>
          <h3>{t('guessCodeFromCountry')}</h3>
          <p>{t('guessCodeDescription')}</p>
        </div>
      </div>

      {/* Leaderboards Section */}
      <div className="main-menu-leaderboards">
        <h3 className="leaderboards-main-title">{t('leaderboards')}</h3>
        
        <div className="leaderboards-grid">
          <LeaderboardDisplay
            gameMode="plate"
            difficulty="easy"
            maxEntries={5}
            showSeeMore={true}
            showBadge={true}
          />
          
          <LeaderboardDisplay
            gameMode="plate"
            difficulty="hard"
            maxEntries={5}
            showSeeMore={true}
            showBadge={true}
          />
          
          <LeaderboardDisplay
            gameMode="code"
            difficulty="easy"
            maxEntries={5}
            showSeeMore={true}
            showBadge={true}
          />
          
          <LeaderboardDisplay
            gameMode="code"
            difficulty="hard"
            maxEntries={5}
            showSeeMore={true}
            showBadge={true}
          />
        </div>
      </div>
    </div>
  );
};

export default ModeSelection;